import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitHouseConsignment } from '@e-origin/shared';

import { TextInput } from '@components';
import { TransitDuplicateRow } from '../../../TransitDuplicateRow';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditGoodsItemFormValues } from './validateTransitViewEditGoodsItemForm';

interface GoodsItemStakeholdersProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  goodsItemForm: UseFormReturnType<TransitViewEditGoodsItemFormValues>;
  houseConsignment: TransitHouseConsignment;
  disabled: boolean;
}

export const GoodsItemStakeholders: React.FC<GoodsItemStakeholdersProps> = (props) => {
  const { form, goodsItemForm, houseConsignment, disabled } = props;

  const additionalSupplyChainActorHeaders = [
    ...(form?.values?.Consignment?.AdditionalSupplyChainActor || []),
    ...(houseConsignment?.AdditionalSupplyChainActor || []),
  ];

  return (
    <Stack mt="md">
      <Title order={5} fw={600}>
        Additional supply chain actor
      </Title>
      {additionalSupplyChainActorHeaders.map((doc, docIdx) => (
        <Grid key={docIdx}>
          <Grid.Col span={6}>
            <TextInput label="Role" value={doc.role} disabled />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput label="Identification number" value={doc.identificationNumber} disabled />
          </Grid.Col>
        </Grid>
      ))}
      <TransitDuplicateRow
        addButtonLabel="Add"
        addButtonDataPW="add-additional-supply-chain-actor-btn"
        form={goodsItemForm}
        inputs={[
          {
            type: 'MultiLang',
            label: 'Role',
            name: 'role',
            code: 'CL704',
            width: 49,
          },
          {
            type: 'Input',
            label: 'Identification number',
            name: 'identificationNumber',
            width: 40,
          },
        ]}
        arrayPath="AdditionalSupplyChainActor"
        disabled={disabled}
      />
    </Stack>
  );
};
